import '../../App.css'
import React, { useContext, useEffect, useState } from 'react'
import Aside from '../../component/aside'
import { useNavigate, useParams } from 'react-router-dom'
import { formatSecondsToTime } from '../../component/formatSecondsToTime'
import Navbar from '../../component/navbar'
import { FormJsonToShamsiDay } from '../../component/FormJsonToShamsiDay'
import Loading from '../../component/loading'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { FormJsonToShamsiTime } from '../../component/FormJsonToShamsiTime'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faUser,
    faIdCard,
    faCalendarDay,
    faClock,
    faCalendarAlt,
    faUserTie,
    faComment,
    faCheck,
    faTimes,
    faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons'
import { AppContextMenu } from '../../App'

function buildApprovalSteps(data) {
    const confirmUsers = data?.confirm_users || []
    const confirmedSteps = confirmUsers.map((item, index) => ({
        id: `confirmed-${index}`,
        name: item?.user?.full_name,
        role: item?.position?.name,
        department: item?.department?.name,
        status: item?.status,
        comment: item?.description,
    }))

    if (data?.status === 'reject' || data?.status === 'confirm') {
        return confirmedSteps
    }

    return [
        ...confirmedSteps,
        {
            id: 'next-approver',
            name: data?.last_requested_position?.name,
            role: 'مرحله بعدی تایید',
            department: data?.last_requested_department?.name,
            status: 'pending',
            comment: 'در انتظار تایید',
        },
    ]
}

function FurloughGetView() {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('furloughGet')
    }, [])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])
    const [dataGet, setDataGet] = useState({})
    const [notFound, setNotFound] = useState(false)
    const [furloughMonthTime, setFurloughMonthTime] = useState('')
    const [confirmedUsers, setConfirmedUsers] = useState([])
    const [approvalSteps, setApprovalSteps] = useState([])
    const [progress, setProgress] = useState(0)

    const authResult = JSON.parse(localStorage.getItem('authResult'))
        ? JSON.parse(localStorage.getItem('authResult'))
        : { user: {} }
    const currentUserId = authResult?.user?.id

    const { id } = useParams()
    let navigate = useNavigate()

    const [description, setDescription] = useState('')

    useEffect(() => {
        getFurlough()
    }, [])

    useEffect(() => {
        const approvedSteps = confirmedUsers.length
        const totalSteps = approvedSteps + 1
        const targetProgress = (approvedSteps / totalSteps) * 100

        const timer = setInterval(() => {
            setProgress((prev) => {
                const diff = targetProgress - prev
                if (Math.abs(diff) < 0.5) {
                    clearInterval(timer)
                    return targetProgress
                }
                return prev + diff * 0.1
            })
        }, 30)

        return () => clearInterval(timer)
    }, [confirmedUsers, dataGet])

    const hasAlreadyResponded = (dataGet?.confirm_users || []).some(
        (item) => item.user?.id === currentUserId
    )
    const canApprove =
        dataGet?.status === 'pending' && !hasAlreadyResponded

    const getFurlough = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/furlough-request/${id}`,
            },
            resolve: (res) => {
                setDataGet(res.data)
                setConfirmedUsers(res.data?.confirm_users || [])
                setApprovalSteps(buildApprovalSteps(res.data))
                getFurloughMonth(res.data.user_id, res.data.start_date)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const getFurloughMonth = async (userId, date) => {
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/furlough-request/current-month/${userId}?date=${date}`,
            },
            resolve: (res) => {
                setFurloughMonthTime(res.data)
            },
            reject: (error) => {
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handlerSubmit = async (status) => {
        if (hasAlreadyResponded) {
            toast.warn('شما قبلاً پاسخ خود را ثبت کرده‌اید', {
                position: 'bottom-center',
            })
            return
        }

        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'patch',
                url: `/furlough-request/${id}`,
                data: { status: status, description: description },
            },
            resolve: (res) => {
                setLoading(false)
                navigate('/')
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const statusLabel = {
        pending: 'در حال بررسی',
        confirm: 'تایید شده',
        reject: 'رد شده',
    }

    const statusColor = {
        pending: 'bg-yellow-100 text-yellow-800',
        confirm: 'bg-green-100 text-green-800',
        reject: 'bg-red-100 text-red-800',
    }

    return (
        <>
            {loading ? <Loading /> : null}

            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />

                    {notFound ? (
                        <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
                            <div className="bg-white p-8 rounded-xl shadow-md text-center max-w-md">
                                <h3 className="text-2xl font-bold text-red-600 mb-4">
                                    درخواست مرخصی یافت نشد
                                </h3>
                                <p className="text-gray-700">
                                    درخواست مربوطه لغو شده یا وجود ندارد
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div className="mx-4 my-6">
                            {/* Summary Card */}
                            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6 shadow-sm">
                                <div className="text-center text-red-800 font-medium">
                                    <span className="font-bold">
                                        مرخصی استفاده شده:
                                    </span>{' '}
                                    {dataGet.user?.full_name || ''}
                                    {furloughMonthTime && (
                                        <span className="block md:inline-block md:mr-4">
                                            {
                                                furloughMonthTime.totalConfirmedFurloughs
                                            }{' '}
                                            مرخصی
                                            <span className="mx-2">|</span>
                                            {formatSecondsToTime(
                                                furloughMonthTime.totalFurloughHours
                                            )}{' '}
                                            ساعت
                                        </span>
                                    )}
                                </div>
                            </div>

                            {dataGet.furlough_entitlement_more_then && (
                                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6 shadow-sm">
                                    <div className="flex items-center justify-center text-amber-800 font-medium">
                                        <FontAwesomeIcon
                                            icon={faExclamationTriangle}
                                            className="ml-2"
                                        />
                                        این درخواست بیش از سقف مرخصی مجاز است
                                    </div>
                                </div>
                            )}

                            {/* Request Details Card */}
                            <div className="bg-white rounded-xl shadow-lg border border-gray-200">
                                <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600 flex justify-between items-center">
                                    <h2 className="text-xl font-bold text-white">
                                        اطلاعات درخواست مرخصی
                                    </h2>
                                    {dataGet.status && (
                                        <span
                                            className={`px-3 py-1 rounded-full text-sm font-medium ${statusColor[dataGet.status] || ''}`}
                                        >
                                            {statusLabel[dataGet.status] ||
                                                dataGet.status}
                                        </span>
                                    )}
                                </div>

                                <div className="p-6">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="bg-gray-50 p-4 rounded-lg">
                                            <div className="flex items-center text-gray-500 mb-1">
                                                <FontAwesomeIcon
                                                    icon={faUser}
                                                    className="ml-2"
                                                />
                                                <span>نام و نام‌خانوادگی</span>
                                            </div>
                                            <div className="font-medium">
                                                {dataGet.user?.full_name || '-'}
                                            </div>
                                        </div>

                                        <div className="bg-gray-50 p-4 rounded-lg">
                                            <div className="flex items-center text-gray-500 mb-1">
                                                <FontAwesomeIcon
                                                    icon={faIdCard}
                                                    className="ml-2"
                                                />
                                                <span>کد پرسنلی</span>
                                            </div>
                                            <div className="font-medium">
                                                {dataGet.user?.personnel_code ||
                                                    '-'}
                                            </div>
                                        </div>

                                        <div className="bg-gray-50 p-4 rounded-lg">
                                            <div className="flex items-center text-gray-500 mb-1">
                                                <FontAwesomeIcon
                                                    icon={faCalendarDay}
                                                    className="ml-2"
                                                />
                                                <span>نوع مرخصی</span>
                                            </div>
                                            <div className="font-medium">
                                                {dataGet.type_furlough ===
                                                'daily'
                                                    ? 'روزانه'
                                                    : 'ساعتی'}
                                            </div>
                                        </div>

                                        <div className="bg-gray-50 p-4 rounded-lg">
                                            <div className="flex items-center text-gray-500 mb-1">
                                                <FontAwesomeIcon
                                                    icon={faCalendarAlt}
                                                    className="ml-2"
                                                />
                                                <span>تاریخ مرخصی</span>
                                            </div>
                                            <div className="font-medium">
                                                {FormJsonToShamsiDay(
                                                    dataGet.start_date
                                                )}
                                                {dataGet.type_furlough ===
                                                    'hourly' && (
                                                    <span>
                                                        {' از '}
                                                        {FormJsonToShamsiTime(
                                                            dataGet.start_date
                                                        )}
                                                        {' تا '}
                                                        {FormJsonToShamsiTime(
                                                            dataGet.end_date
                                                        )}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {dataGet.type_furlough === 'hourly' && (
                                            <div className="bg-gray-50 p-4 rounded-lg">
                                                <div className="flex items-center text-gray-500 mb-1">
                                                    <FontAwesomeIcon
                                                        icon={faClock}
                                                        className="ml-2"
                                                    />
                                                    <span>مدت مرخصی</span>
                                                </div>
                                                <div className="font-medium">
                                                    {formatSecondsToTime(
                                                        dataGet.furlough_hour
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        <div className="bg-gray-50 p-4 rounded-lg">
                                            <div className="flex items-center text-gray-500 mb-1">
                                                <FontAwesomeIcon
                                                    icon={faCalendarAlt}
                                                    className="ml-2"
                                                />
                                                <span>تاریخ ثبت درخواست</span>
                                            </div>
                                            <div className="font-medium">
                                                {FormJsonToShamsiDay(
                                                    dataGet.created_at
                                                )}
                                                {'، '}
                                                {FormJsonToShamsiTime(
                                                    dataGet.created_at
                                                )}
                                            </div>
                                        </div>

                                        {dataGet.last_requested_department && (
                                            <div className="bg-gray-50 p-4 rounded-lg">
                                                <div className="flex items-center text-gray-500 mb-1">
                                                    <FontAwesomeIcon
                                                        icon={faUserTie}
                                                        className="ml-2"
                                                    />
                                                    <span>واحد درخواست</span>
                                                </div>
                                                <div className="font-medium">
                                                    {
                                                        dataGet
                                                            .last_requested_department
                                                            .name
                                                    }
                                                </div>
                                            </div>
                                        )}

                                        {dataGet.last_requested_position && (
                                            <div className="bg-gray-50 p-4 rounded-lg">
                                                <div className="flex items-center text-gray-500 mb-1">
                                                    <FontAwesomeIcon
                                                        icon={faUserTie}
                                                        className="ml-2"
                                                    />
                                                    <span>سمت درخواست</span>
                                                </div>
                                                <div className="font-medium">
                                                    {
                                                        dataGet
                                                            .last_requested_position
                                                            .name
                                                    }
                                                </div>
                                            </div>
                                        )}

                                        {dataGet.substitute_person && (
                                            <div className="bg-gray-50 p-4 rounded-lg">
                                                <div className="flex items-center text-gray-500 mb-1">
                                                    <FontAwesomeIcon
                                                        icon={faUser}
                                                        className="ml-2"
                                                    />
                                                    <span>جانشین</span>
                                                </div>
                                                <div className="font-medium">
                                                    {
                                                        dataGet
                                                            .substitute_person
                                                            .full_name
                                                    }
                                                </div>
                                            </div>
                                        )}

                                        <div className="bg-gray-50 p-4 rounded-lg md:col-span-2">
                                            <div className="flex items-center text-gray-500 mb-1">
                                                <FontAwesomeIcon
                                                    icon={faComment}
                                                    className="ml-2"
                                                />
                                                <span>درجه فوریت</span>
                                            </div>
                                            <div className="font-medium">
                                                {dataGet.description ||
                                                    'بدون درجه فوریت'}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Approval Workflow */}
                                    <div className="mt-8">
                                        <h3 className="text-lg font-semibold text-gray-800 mb-4">
                                            روند تایید مرخصی
                                        </h3>

                                        <div className="relative mb-8">
                                            <div className="h-3 bg-gray-200 rounded-full overflow-hidden">
                                                <div
                                                    className={`h-full bg-gradient-to-l ${dataGet?.status === 'pending' && 'from-yellow-400 to-yellow-600'} ${dataGet?.status === 'confirm' && 'from-green-400 to-green-600'} ${dataGet?.status === 'reject' && 'from-red-400 to-red-600'} rounded-full transition-all duration-500 ease-out`}
                                                    style={{
                                                        width: `${dataGet?.status === 'pending' ? progress : '100'}%`,
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="space-y-4">
                                            {approvalSteps.map((step) => (
                                                <div
                                                    key={step.id}
                                                    className={`p-4 rounded-lg border-l-4 transition-all duration-300
                                                        ${step.status === 'confirm' ? 'border-green-500 bg-green-50' : ''}
                                                        ${step.status === 'pending' ? 'border-yellow-500 bg-yellow-50 animate-pulse' : ''}
                                                        ${step.status === 'reject' ? 'border-red-500 bg-red-50' : ''}
                                                    `}
                                                >
                                                    <div className="flex justify-between items-center">
                                                        <div>
                                                            <h4 className="font-medium">
                                                                {step.name}
                                                            </h4>
                                                            <div className="flex flex-wrap gap-2 mt-1">
                                                                <span className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded">
                                                                    {step.role}
                                                                </span>
                                                                {step.department && (
                                                                    <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                                                                        {
                                                                            step.department
                                                                        }
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            {step.status ===
                                                                'confirm' && (
                                                                <span className="px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full flex items-center">
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faCheck
                                                                        }
                                                                        className="w-3 h-3 ml-1"
                                                                    />
                                                                    تایید شده
                                                                </span>
                                                            )}
                                                            {step.status ===
                                                                'pending' && (
                                                                <span className="px-3 py-1 bg-yellow-100 text-yellow-800 text-sm rounded-full">
                                                                    در انتظار
                                                                    تایید
                                                                </span>
                                                            )}
                                                            {step.status ===
                                                                'reject' && (
                                                                <span className="px-3 py-1 bg-red-100 text-red-800 text-sm rounded-full flex items-center">
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faTimes
                                                                        }
                                                                        className="w-3 h-3 ml-1"
                                                                    />
                                                                    رد شده
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {step.comment && (
                                                        <div className="mt-3 p-2 bg-white rounded text-sm text-gray-700 border border-gray-200">
                                                            <span className="font-medium">
                                                                نظر {step.name}:{' '}
                                                            </span>
                                                            {step.comment}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        <div
                                            className={`mt-6 p-3 rounded-lg text-center font-medium
                                                ${dataGet?.status === 'pending' ? 'bg-yellow-100 text-yellow-800' : ''}
                                                ${dataGet?.status === 'confirm' ? 'bg-green-100 text-green-800' : ''}
                                                ${dataGet?.status === 'reject' ? 'bg-red-100 text-red-800' : ''}
                                            `}
                                        >
                                            {dataGet?.status === 'pending' &&
                                                'درخواست در حال بررسی است'}
                                            {dataGet?.status === 'confirm' &&
                                                'درخواست تایید شده است'}
                                            {dataGet?.status === 'reject' &&
                                                'درخواست رد شده است'}
                                        </div>
                                    </div>

                                    {/* Approval Actions */}
                                    {canApprove && (
                                        <div className="mt-8 border-t border-gray-200 pt-8">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                توضیحات برای{' '}
                                                {dataGet?.user?.full_name}
                                            </label>
                                            <textarea
                                                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                                rows={3}
                                                placeholder="توضیحات خود را وارد کنید..."
                                                value={description}
                                                onChange={(e) =>
                                                    setDescription(
                                                        e.target.value
                                                    )
                                                }
                                            ></textarea>

                                            <div className="flex justify-end space-x-3 space-x-reverse mt-6">
                                                <button
                                                    onClick={() =>
                                                        handlerSubmit('reject')
                                                    }
                                                    className="px-6 py-3 border border-red-500 text-red-600 bg-white hover:bg-red-50 rounded-xl transition-colors flex items-center"
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faTimes}
                                                        className="ml-2"
                                                    />
                                                    رد درخواست
                                                </button>
                                                <button
                                                    onClick={() =>
                                                        handlerSubmit(
                                                            'confirm'
                                                        )
                                                    }
                                                    className="px-6 py-3 bg-gradient-to-r from-green-600 to-green-500 text-white hover:from-green-700 hover:to-green-600 rounded-xl shadow-md hover:shadow-lg transition-all flex items-center"
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faCheck}
                                                        className="ml-2"
                                                    />
                                                    تایید درخواست
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {hasAlreadyResponded &&
                                        dataGet?.status === 'pending' && (
                                            <div className="mt-8 border-t border-gray-200 pt-8">
                                                <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 text-center text-blue-800 font-medium">
                                                    شما قبلاً پاسخ خود را برای
                                                    این درخواست ثبت کرده‌اید
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    )}
                </main>
            </div>
        </>
    )
}

export default FurloughGetView
